import React, { PropsWithChildren } from "react";
import {
  IconSize,
  IconContainer,
} from "@/src/components/icons/components/IconContainer";
import { Popover } from "@headlessui/react";

export type TooltipButtonProps = PropsWithChildren<{
  icon: React.ReactNode;
  size?: IconSize;
  /* ARIA Label that describes the button's action */
  label: string;
}>;

const TooltipButton: React.FC<TooltipButtonProps> = ({
  label,
  icon,
  size = IconSize.sm,
}) => {
  return (
    <Popover.Button aria-label={label}>
      <IconContainer size={size}>{icon}</IconContainer>
    </Popover.Button>
  );
};

export default TooltipButton;
